import { formatDateForDisplay } from "@/lib/utils";
import { TagCell } from "components/cell/tag/cell";

export const TITLE = "Table";

export const COLUMNS = [
  {
    id: "date",
    header: "Date",
    accessorKey: "date",
    sortable: true,
    cell: (info) => formatDateForDisplay(info.getValue()),
  },
  {
    id: "project",
    header: "Project",
    accessorKey: "project.name",
    sortable: true,
  },
  {
    id: "job",
    header: "Job",
    accessorKey: "job.name",
    sortable: true,
  },
  {
    id: "tag",
    header: "Tag",
    accessorKey: "tag",
    sortable: true,
    cell: TagCell,
  },
  {
    id: "logged_hours",
    header: "Logged",
    accessorKey: "logged_hours",
    sortable: true,

    cell: (info) => {
      const hours = info.getValue();
      return hours ? hours : "0";
    },
  },
  {
    id: "approved_hours",
    header: "Approved",
    accessorKey: "approved_hours",
    sortable: true,

    cell: (info) => {
      const hours = info.getValue();
      return hours ? hours : "0";
    },
  },
  {
    id: "unapproved_hours",
    header: "Unapproved",
    accessorKey: "unapproved_hours",
    sortable: true,

    cell: (info) => {
      const hours = info.getValue();
      return hours ? hours : "0";
    },
  },
];

export const FIELDS = [
  "id",
  "logged_hours",
  "approved_hours",
  "unapproved_hours",
  "date",
  "employee.first_name",
  "employee.last_name",
  "project.name",
  "project.id",
  "job.name",
  "job.id",
  "tag.id",
  "tag.label",
  "tag.color",
];

export const DEFAULT_FILTERS = {
  employee: "$CURRENT_USER",
  logged_hours: {
    _gt: 0,
  },
};
